import { motion } from "framer-motion";

const CLIENTS = [
  { id: "bombers", name: "Whatcom Bombers", src: "/assets/client-bombers.png", url: "https://whatcombombers.com", size: "h-14 sm:h-16" },
  { id: "celebrity", name: "Celebrity Barbershop & Salon", src: "/assets/client-celebrity.png", url: "https://celebritybarbershopandsalon.com", size: "h-16 sm:h-20" },
];

export function ClientLogoStrip() {
  const set = [...CLIENTS, ...CLIENTS, ...CLIENTS];
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5, duration: 1 }}
      data-testid="client-logo-strip"
      className="marquee-mask w-full max-w-3xl overflow-hidden"
    >
      <div className="animate-marquee flex w-max items-center py-2">
        {[...set, ...set].map((c, i) => (
          <span key={`${c.id}-${i}`}
            data-testid={i < CLIENTS.length ? `client-logo-${c.id}` : undefined}
            className="shrink-0 inline-block sm:translate-y-2 px-7 sm:px-10 opacity-90 hover:opacity-100 hover:[filter:drop-shadow(0_0_14px_rgba(212,175,55,0.35))] transition-all duration-500">
            <img src={c.src} alt={c.name} className={`${c.size} w-auto object-contain`} draggable={false} />
          </span>
        ))}
      </div>
    </motion.div>
  );
}
